import React, { useState } from "react";
import "../../style/pages/categoriespage/cases.css";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header.jsx";


import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import c1 from "../../media3/categories/c1.png";
import c2 from "../../media3/categories/c2.png";
import c3 from "../../media3/categories/c3.png";
import c4 from "../../media3/categories/c4.png";
import c5 from "../../media3/categories/c5.png";
import c6 from "../../media3/categories/c6.png";
import c7 from "../../media3/categories/c7.png";
import c8 from "../../media3/categories/c8.png";
import c9 from "../../media3/categories/c9.png";
import c10 from "../../media3/categories/c10.png";
import c11 from "../../media3/categories/c11.png";
import c12 from "../../media3/categories/c12.png";
import c13 from "../../media3/categories/c13.png";
import c14 from "../../media3/categories/c14.png";
import c15 from "../../media3/categories/c15.png";
import c16 from "../../media3/categories/c16.png";
import c17 from "../../media3/categories/c17.png";
import c18 from "../../media3/categories/c18.png";
import c19 from "../../media3/categories/c19.png";
import c20 from "../../media3/categories/c20.png";
import c21 from "../../media3/categories/c21.png";
import c22 from "../../media3/categories/c22.png";
import c23 from "../../media3/categories/c23.png";
import c24 from "../../media3/categories/c24.png";
import c from "../../media3/categories/c.png";

// Dummy data
export const casesData = [
  { id: 1, name: "Danger Zone Case | Slalom", img: c1, price: 61, maxPrice: 122, color: "blue", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Danger Zone Case featuring blue Slalom ski-themed artwork, packed with high-adrenaline drops for survival mode." },
  { id: 2, name: "Fracture Case | Blaze", img: c2, price: 80, maxPrice: 150, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Fracture Case engulfed in fiery yellow Blaze design, shattering expectations with elite covert weapon skins." },
  { id: 3, name: "Prisma Case | Fade", img: c3, price: 95, maxPrice: 160, color: "purple", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Prisma Case with stunning purple-to-blue Fade gradient, refracting light and revealing chromatic treasures inside." },
  { id: 4, name: "Clutch Case | Orion", img: c4, price: 120, maxPrice: 180, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Clutch Case in cosmic orange Orion constellation theme, delivering stellar high-stakes drops for decisive moments." },
  { id: 5, name: "Horizon Case | See Ya Later", img: c5, price: 70, maxPrice: 125, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Horizon Case with bold yellow 'See Ya Later' mechanical gator, waving goodbye to enemies with fun, fierce skins." },
  { id: 6, name: "Spectrum Case | Hyper", img: c6, price: 90, maxPrice: 140, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Spectrum Case roaring with orange Hyper Beast monster art, unleashing a rainbow of classified weapon finishes." },
  { id: 7, name: "Glove Case | Fuel Injector", img: c7, price: 110, maxPrice: 160, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Glove Case with industrial yellow Fuel Injector mechanics, powering up rare gloves and high-performance skins." },
  { id: 8, name: "Gamma Case | Melondrama", img: c8, price: 60, maxPrice: 120, color: "red", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Gamma Case in juicy red Melondrama watermelon theme, slicing open refreshing restricted-tier drops." },
  { id: 9, name: "Chroma Case | Cannon", img: c9, price: 75, maxPrice: 130, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Chroma Case featuring explosive yellow Llama Cannon artwork, firing vibrant doppler and marbleized finishes." },
  { id: 10, name: "Operation | Kill Confirmed", img: c10, price: 145, maxPrice: 200, color: "black", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Operation case marked with black Kill Confirmed blood and bullet holes—proof of mission success and elite rewards." },
  { id: 11, name: "Phoenix Case | Queen", img: c11, price: 88, maxPrice: 150, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Phoenix Case crowned in golden yellow Bullet Queen royalty, rising from ashes with regal weapon skins." },
  { id: 12, name: "Shadow Case | Handgun", img: c12, price: 55, maxPrice: 110, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Shadow Case with yellow Handgun silhouette, lurking in darkness with stealthy pistol and SMG potential." },
  { id: 13, name: "Falchion Case | Avalanche", img: c13, price: 68, maxPrice: 125, color: "yellow", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "Falchion Case in yellow Avalanche snowy rush, concealing blade skins suited for winter warfare." },
  { id: 14, name: "Revolver Case | Xiangliu", img: c14, price: 92, maxPrice: 160, color: "black", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Revolver Case coiled in black Xiangliu mythical serpent, spinning ancient power into revolver and knife drops." },
  { id: 15, name: "Wildfire Case | Muertos", img: c15, price: 63, maxPrice: 120, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Wildfire Case with blue Muertos Day of the Dead skulls, burning bright with cultural and fiery restricted skins." },
  { id: 16, name: "CS20 Case | Angry Mob", img: c16, price: 85, maxPrice: 140, color: "red", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "CS20 anniversary case in red Angry Mob protest theme, celebrating 20 years with rebellious, high-tier drops." },
  { id: 17, name: "Operation7| Cobra Strike", img: c17, price: 78, maxPrice: 130, color: "purple", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Operation case with purple Cobra Strike venom, striking silently with exclusive operation weapon skins." },
  { id: 18, name: "Spectrum 2 Case | Crazy 8", img: c18, price: 59, maxPrice: 110, color: "blue", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Spectrum 2 Case with chaotic blue Crazy 8 dice design, gambling on vibrant chroma and marble finishes." },
  { id: 19, name: "Prisma 2 Case |  Hell", img: c19, price: 99, maxPrice: 160, color: "white", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Prisma 2 Case burning with white-hot Ticket to Hell flames, opening portals to infernal classified skins." },
  { id: 20, name: "Shattered | Elemental", img: c20, price: 115, maxPrice: 175, color: "green", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Shattered Web Case with green Water Elemental waves, hiding mystical and shattered glass-inspired covert drops." },
  { id: 21, name: "Vanguard Case | Asiimov", img: c21, price: 102, maxPrice: 155, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Operation Vanguard Case in orange Asiimov future-tech, pioneering sci-fi weapon and knife upgrades." },
  { id: 22, name: "Chroma Case | Position", img: c22, price: 66, maxPrice: 125, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Chroma Case in yellow Pole Position racing stripes, speeding through doppler and pearl finish collections." },
  { id: 23, name: "Huntsman Case | Isaac", img: c23, price: 74, maxPrice: 130, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Huntsman Case with yellow Isaac holographic circuits, hunting high-tech knife and weapon possibilities." },
  { id: 24, name: "Gamma 2 Case | Protocol", img: c24, price: 97, maxPrice: 160, color: "black", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Gamma 2 Case in sleek black Boost Protocol cyber theme, containing elite overclocked covert weapon skins." }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Cases({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
  const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  // const filteredCases = casesData.filter((item) => {
  //   const inPrice = item.price >= priceRange[0] && item.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(item.color);
  //   const inRating = !selectedRating || item.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });
    let filteredCases = casesData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredCases = [...filteredCases].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };

  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

   const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };


  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
          <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
         <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
            selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredCases}
          categoryImage={c}
          categoryAlt="CZ75-Auto"
          categoryTitle="Chroma Case2 | Position"
          categoryDescription="Unlock the thrill of discovery with our wide range of CS2 Cases.
Each case holds the chance to reveal rare knives, gloves, and weapon skins that define your style.
From common drops to covert treasures, every opening tells a new story.
"
          onItemClick={handleNavigate}
            isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Cases;